var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { attrs: { id: "global-top-nav-region" } }, [
      _c("div", { staticClass: "sfi-static-header" }, [
        _c(
          "div",
          { staticClass: "container sfi-static-header-content" },
          [
            _c("logo", {
              staticClass: "generic-logo",
              attrs: {
                imgMarginTop: _vm.logoMarginTop,
                imgWidth: _vm.logoWidth
              }
            }),
            _vm._v(" "),
            _vm.insuranceType.contactUsLink
              ? _c("p", { staticClass: "contact" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.insuranceType.contactUsLink,
                        name: _vm.analyticsConstants.CONTACT_US
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons phone" }, [
                        _vm._v("phone")
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(" Contact Us ")])
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bcc4664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcc4664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/sfi-header.vue
// module id = null
// module chunks = 